import _get from "lodash/get";
import _reduce from "lodash/reduce";
import _head from "lodash/head";
import _find from "lodash/find";
import _findIndex from "lodash/findIndex";
import _filter from "lodash/filter";
import _isEmpty from "lodash/isEmpty";
import _map from "lodash/map";
import _round from "lodash/round";

import {
    CART_SHOULD_UPDATE_TOTALS,
    CART_SET_TOTALS,
    UNDEFINED_ERROR
} from '../actions/actionTypes';


const updateTotalsMiddleware = store => next => action => {

    next(action); // pass the original

    if (action.type === CART_SHOULD_UPDATE_TOTALS) {

        const state = store.getState();

        try{
            const cart = state.cart;
            let totals = state.cart.totals;
            const currency = state.personal.currency_code;
            const coupons = state.coupon;
            const coupon_id = _head(coupons.byId);
            let coupon = null;
            if(coupon_id)
            {
                coupon = coupons.byHash[coupon_id].content;
            }
            totals.discount = 0;
            if (coupon)
            {
                totals.discount = _reduce(cart.byHash, function(sum, n) {
                    let CurrencyIndex = _findIndex(n.content.currencies, ['currency_code', currency]);
                    let result = _filter(coupon.discounted_variants, o => o == n.id); //double equal on purpose as ids are coming as int & string
                    if (!_isEmpty(result)){
                        const qty = _get(cart, 'qtyByHash['+ n.id +']', 1);
                        return sum + (n.content.currencies[CurrencyIndex].price * qty) * coupon.percentage / 100
                    }
                    return sum
                }, 0);
            }

            totals.shipping = 0;
            totals.shipping_lines = _filter(_map(state.shipping.availableOptions, (item, index) => {
                    const option = _find(state.shipping.byHash, ['seller_id', item.seller_id]);
                    const selected_option_id = option ? option.option_id : 0;
                    const selected_option = _find(item.shippingOptions.zoneOptions, ['id', selected_option_id]);

                    if (selected_option){
                        const priceIndex = _findIndex(selected_option.prices, ['currency_code', currency]);
                        return {
                            "price": selected_option.prices[priceIndex].price,
                            "name": selected_option.name,
                            "seller_name": item.seller_name
                        };
                    }
                }
            ));

            totals.shipping = _reduce(totals.shipping_lines, (sum, n) => sum + n.price, 0);

            totals.subtotal = _reduce(cart.byHash, function(sum, n) {
                let CurrencyIndex = _findIndex(n.content.currencies, ['currency_code', currency]);
                const qty = _get(cart, 'qtyByHash['+ n.id +']', 1);

                return sum + _round((n.content.currencies[CurrencyIndex].price) * qty)
            }, 0);

            totals.total = _round(totals.subtotal + (totals.shipping ? totals.shipping : 0) - totals.discount);

            store.dispatch({ type: CART_SET_TOTALS, payload: totals });
        }catch(error) {
            store.dispatch({type: UNDEFINED_ERROR, error: 'Error calculating total for these products'});
        }


    }
};

export default updateTotalsMiddleware